import { EBoxEventSaveNameAction } from '@lbs/shared-rp-types'
import mitt from 'mitt'

export type BoxEventName = `gameId:${string}:sessionId:${string}:seatNumber:${string}`

export function getBoxEventName(params: {
  gameId: string
  sessionId: string
  seatNumber: string | number
}): BoxEventName {
  const { gameId, sessionId, seatNumber } = params
  return `gameId:${gameId}:sessionId:${sessionId}:seatNumber:${seatNumber}`
}

export type Events = {
  [key in BoxEventName]: EBoxEventSaveNameAction
}

const eventBus = mitt<Events>()

export default eventBus
